<!--限速区域设置-->
<template>
  <div style="height: 100%; text-align: left">
    <div>
      <el-tabs v-model="activeName">
        <el-tab-pane
          :label="$t('arealimitset.tab3')"
          name="first"
        ></el-tab-pane>
        <el-tab-pane
          :label="$t('arealimitset.tab2')"
          name="second"
        ></el-tab-pane>
      </el-tabs>
    </div>
    <el-row style="height: 100%">
      <el-col :span="8" style="height: 100%">
        <div
          style="
            border: 1px solid #c5d0e2;
            height: calc(100vh - 230px);
            margin-right: 16px;
            border-radius: 4px;
            padding: 16px;
          "
        >
          <div v-if="activeName == 'first'">
            <limitarearemindset_arealist :map="map" />
          </div>

          <div v-if="activeName == 'second'">
            <limitarearemindset_vehiclelist :map="map" />
          </div></div
      ></el-col>
      <el-col :span="16"
        ><div
          style="
            width: 100%;
            height: calc(100vh - 200px);
            background-color: #fff;
          "
        >
          <KingLongMap
            ref="map"
            mapId="content_0"
            @DrawRectangleCompleted="DrawRectangleCompleted"
            @DrawPolygonCompleted="DrawPolygonCompleted"
            @DrawCircleCompleted="DrawCircleCompleted"
            @LoadCompleted="MapLoadCompleted"
          /></div
      ></el-col>
    </el-row>
  </div>
</template>
<script>
import KingLongMap from "@/components/KingLongMap.vue";

import limitarearemindset_arealist from "./limitarearemindset_arealist";
import limitarearemindset_vehiclelist from "./limitarearemindset_vehiclelist";

export default {
  components: {
    KingLongMap,
    limitarearemindset_arealist,
    limitarearemindset_vehiclelist,
  },
  computed: {
    size() {
      return this.$store.getters.size;
    },
  },
  data() {
    return {
      map: undefined,

      date: [],
      activeName: "first",
      form: {
        AreaName: "",
        PageNo: 1,
        PageSize: 10,
      },
      loading: false,
      total: 100,
      tableData: [],
      currentRow: undefined,
    };
  },
  mounted() {},
  methods: {
    MapLoadCompleted() {
      this.map = this.$refs.map;
    },

    DrawRectangleCompleted(lng1, lat1, lng2, lat2) {
      console.log(lng1, lat1, lng2, lat2);
    },
    DrawPolygonCompleted(lnglats) {
      console.log(lnglats);
    },

    DrawCircleCompleted(lng, lat, radius) {
      console.log(lng, lat, radius);
    },
  },
};
</script>
<style>
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>
